import React, { useContext } from 'react'
import './RelatedProduct.css'
// import date_product from '../Assets/data'
import Item from '../Items/Item'
import { ShopContext } from '../../Context/ShopContext'

const RelatedProduct = ({check_category,crt_product,productId}) => {
  const {All_product}=useContext(ShopContext);
  let related_product=All_product.filter((e)=>e.category===check_category && e.id!=Number(productId)).slice(0,4);
  
  return (
    <div className='relatedproducts'>
        <h1>Related Products</h1>
        <hr />
        <div className="relatedproduct-items">
        {related_product.map((item,i)=>{
            return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
        })}
        </div>
    </div>
  )
}

export default RelatedProduct
